import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import zhHant from 'vuetify/es5/locale/zh-Hant';
import * as directives from 'vuetify/es5/directives';

Vue.use(Vuetify, {
  theme: {
    primary: '#e69d00',
    secondary: '#FFDE03',
    // accent: '#EA80FC',
    // secondary: '#ffcf66',
    accent: '#6db6f9',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#f1b400'
  },
  customProperties: true,
  iconfont: 'mdi',
  lang: {
    locales: {zhHant},
    current: 'zh-Hant'
  },
  directives: directives
});
